const expenseInitialValues = {

    operateId: "0",

    operKindId: "0",

    carId: "",

    operDonDate: new Date()
        .toISOString()
        .split("T")[0],

    cost: "",

    categoryId: "",

    operDonKM: "",

    description: "",

    imageFile: null,

    opTitle: "EM",

};

export default expenseInitialValues;
